import { fromEvent, merge, of, timer, SchedulerLike } from 'rxjs';
import {
  mergeMap,
  switchMap,
  delay,
  takeUntil,
  debounceTime,
} from 'rxjs/operators';
import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';

/**
 * Directive that calls provided callback after clicking & holding for 2s.
 */
angular
  .module('coreModule')
  .directive(
    'swHold',
    (
      $translate: ng.translate.ITranslateService,
      scheduler: SchedulerLike,
      scopeStreams: ScopeStreams,
    ) => ({
      restrict: 'A',

      link: function (scope: any, element, attrs) {
        const clickDelay = 2000,
          messageTimeout = 2000,
          shortClick = 500;

        const destroyed$ = scopeStreams.isDestroyed(scope),
          mousedown$ = fromEvent(element, 'mousedown'),
          touchstart$ = fromEvent(element, 'touchstart'),
          touchend$ = fromEvent(element, 'touchend'),
          mouseup$ = fromEvent(element, 'mouseup');

        // Hack! To be replaced by custom operator rx operator
        const wrapInSafeApply = require('@global/wrap-in-safe-apply')(scope);

        const start$ = merge(mousedown$, touchstart$),
          end$ = merge(touchend$, mouseup$),
          delayedClick$ = start$.pipe(
            mergeMap((val) =>
              of(val).pipe(delay(clickDelay, scheduler), takeUntil(end$)),
            ),
          ),
          shortHold$ = start$.pipe(
            switchMap(() => end$.pipe(takeUntil(timer(shortClick, scheduler)))),
          );

        end$
          .pipe(debounceTime(messageTimeout), takeUntil(destroyed$))
          .subscribe(
            wrapInSafeApply(() => {
              element.removeClass('sw-hold--help');
            }),
          );

        shortHold$.pipe(takeUntil(destroyed$)).subscribe(
          wrapInSafeApply(() => {
            element.addClass('sw-hold--help');
            element.attr(
              'data-tooltip',
              $translate.instant('core.sw-hold__help'),
            );
          }),
        );

        delayedClick$.pipe(takeUntil(destroyed$)).subscribe(
          wrapInSafeApply(() => {
            scope.$eval(attrs.swHold);
          }),
        );
      },
    }),
  );
